import React from 'react';
import { useFormik } from 'formik';
import AppInput from '../../../base/input';
import { isFutureDate } from '../../../../utils/dates.util';
import kybUpdateValidationSchemas from '../../../../constants/schemas/kyb-update';
import AppDatePicker from '../../../base/date-picker';
import toast from 'react-hot-toast';

const BasicInformation = () => {
  const handleRelationshipDateChange = (date: Date | null) => {
    if (isFutureDate(date)) {
      formik.setFieldValue('relationshipEstablishedAt', null);
      return toast.error('Date cannot be in the future');
    }
    formik.setFieldValue('relationshipEstablishedAt', date);
  };

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      dateOfBirth: null,
      relationshipEstablishedAt: null,
    },
    enableReinitialize: true,
    validationSchema: kybUpdateValidationSchemas[0],
    validateOnMount: true,
    onSubmit: () => {},
  });

  return (
    <div className="p-4 rounded-xl gap-8 flex flex-col border border-[#F1F2F4] w-full h-full bg-white ">
      <div className="grid gap-6">
        <p className="ryno_text_semibold">Basic Information</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* First Name */}
          <div>
            <AppInput
              type="text"
              name="firstName"
              id="firstName"
              onChange={formik.handleChange}
              placeholder="Enter your first name"
              required
              label="First name"
              onBlur={formik.handleBlur}
              value={formik.values.firstName}
              errorMessage={
                formik.touched.firstName && formik.errors.firstName
                  ? formik.errors.firstName
                  : ''
              }
            />
          </div>

          {/* Last Name */}
          <div>
            <AppInput
              type="text"
              name="lastName"
              id="lastName"
              onChange={formik.handleChange}
              placeholder="Enter your last name"
              required
              label="Last name"
              onBlur={formik.handleBlur}
              value={formik.values.lastName}
              errorMessage={
                formik.touched.lastName && formik.errors.lastName
                  ? formik.errors.lastName
                  : ''
              }
            />
          </div>

          {/* Email Address */}
          <div>
            <AppInput
              type="text"
              name="email"
              id="email"
              onChange={formik.handleChange}
              placeholder="Enter your email address"
              required
              label="Email address"
              onBlur={formik.handleBlur}
              value={formik.values.email}
              errorMessage={
                formik.touched.email && formik.errors.email
                  ? formik.errors.email
                  : ''
              }
            />
          </div>

          {/* Phone Number */}
          <div>
            <AppInput
              type="text"
              name="phoneNumber"
              id="phoneNumber"
              onChange={formik.handleChange}
              placeholder="Enter your phone number"
              required
              label="phone number"
              onBlur={formik.handleBlur}
              value={formik.values.phoneNumber}
              errorMessage={
                formik.touched.phoneNumber && formik.errors.phoneNumber
                  ? formik.errors.phoneNumber
                  : ''
              }
            />
          </div>

          {/* Relationship Established Date */}
          <div>
            <AppDatePicker
              label="Relationship Established At"
              placeholder='Type "yyyy-mm-dd" or select from calendar'
              required
              value={formik.values.relationshipEstablishedAt}
              onChange={(date) => handleRelationshipDateChange(date)}
            />
          </div>

          {/*  Date of Birth */}
          <div>
            <AppDatePicker
              label=" Date of Birth"
              placeholder='Type "yyyy-mm-dd" or select from calendar'
              required
              value={formik.values.relationshipEstablishedAt}
              onChange={(date) => handleRelationshipDateChange(date)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInformation;
